/*
 * Usage:
 * <Icon className="map-loader spin" type="loading" />
 */
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const Icon = memo(({ type, className = null, style = {}, ...rest }) => {
  const classes = classnames('icon', `icon-${type}`, className);
  const href = `spritemap.svg#icon-${type}`;

  return (
    <svg className={classes} style={style} {...rest} role="img" aria-label={`Logo ${type}`}>
      <use xlinkHref={href}></use>
    </svg>
  );
});

Icon.displayName = 'Icon';

Icon.propTypes = {
  type: PropTypes.string.isRequired,
  className: PropTypes.string,
};

Icon.defaultProps = {
  className: null,
};

export default Icon;
